import ActionSelector from '../../components/ActionSelector'
import { useModuleAction } from '../../hooks/useModuleAction'
import { type EpochAction } from './constants'
import StartEpochForm from './StartEpochForm'

export default function EpochModule() {
  const { selectedAction, selectAction, isValidAction } =
    useModuleAction('epoch')

  const formByAction = {
    start: StartEpochForm,
  } satisfies Record<EpochAction, React.ComponentType>

  const Form = selectedAction ? formByAction[selectedAction] : null

  if (!isValidAction) {
    return <ActionSelector module='epoch' onSelectAction={selectAction} />
  }

  return <div className='space-y-4'>{Form && <Form />}</div>
}
